<table>
  @for (data of tableData; track $index) {
    <tr>
      @for (dataCount of getDataRowArray(data); track $index) {
        <td>
          <markdown [data]="getNextDataInfo(data)"></markdown>
        </td>
      }
    </tr>
  }
</table>
